import React, { useEffect, useState } from "react";

//Local components
import ErrorBox from "../Components/ErrorBox";
import DataLoader from "../Components/basics/DataLoader";
import ProductSummary from "../Components/product-page/ProductSummary";
import ProductInfo from "../Components/product-page/ProductInfo";

//UI Material
import { Breadcrumbs, Grid, Link } from "@mui/material";

//Helpers
import { fetchWithTokenJSONPost } from "../Helpers/network";
import ProductPreferencesConfiguration from "../Components/product-page/ProductPreferencesConfiguration";

export default function Product() {
  // ==========> Component States<==========
  //State for store product data
  const [productData, setProductData] = useState({});
  //State for loading
  const [dataLoader, setDataLoader] = useState(false);
  //State for error case
  const [dataError, setDataError] = useState(false);

  // ==========> Component Functions <==========
  //Function to get product data from db
  const getProductData = async () => {
    try {
      const requestResponse = await fetchWithTokenJSONPost(
        `/products/get-product`,
        {
          productId: Number(
            new URLSearchParams(window.location.search).get("productId")
          ),
        }
      );
      const jsonResponse = await requestResponse.json();
      setProductData(jsonResponse.data);
    } catch (error) {
      setDataError(true);
    }
    setDataLoader(false);
  };

  // ==========> Component UseEffects <==========
  //UseEffect to get product data when rendering
  useEffect(() => {
    getProductData();
  }, []);

  // ==========> Component <==========
  if (dataLoader) {
    return <DataLoader />;
  }

  return dataError ? (
    <ErrorBox />
  ) : (
    <Grid
      container
      spacing={1}
      justifyContent="flex-start"
      textAlign="center"
      sx={{ padding: "15px" }}
    >
      <Grid item xs={12} sx={{ mb: 1 }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="/products">
            Productos
          </Link>
          <Link underline="hover" color="text.primary" aria-current="page">
            {`Producto ${new URLSearchParams(window.location.search).get(
              "productId"
            )}`}
          </Link>
        </Breadcrumbs>
      </Grid>
      <Grid item xs={12} md={3} xl={2}>
        <ProductSummary data={productData} />
      </Grid>
      <Grid item xs={12} md={9} xl={10}>
        <Grid container spacing={1} alignItems="stretch" alignContent="stretch">
          <Grid item xs={12}>
            <ProductInfo data={productData} getProduct={getProductData} />
          </Grid>
          <Grid item xs={12} md={6}>
            <ProductPreferencesConfiguration
              data={productData}
              getProduct={getProductData}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
